(ns client-portal.client.reports.components.table
  (:require [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.utils.currency :as currency]))

(defn- format-cell
  "Render one cell value using the header's optional `value-type`: currency/percent/
   number format the number; location/concept map a raw id to its name via
   `id->name` (a map of value-type -> {id-string name}); anything else is shown
   as-is, with a dash for missing values."
  [value value-type country-code id->name]
  (cond
    (nil? value) "—"
    (= value-type "currency") (currency/currency-integer->readable-currency (or country-code "US") value)
    (= value-type "percent") (str (util/to-precision-num (* value 100) :precision 2) "%")
    (= value-type "number") (util/readable-number value)
    (contains? id->name value-type) (get (get id->name value-type) (str value) (str value))
    :else (str value)))

(defn- ->string-keyed
  "A {id name} lookup with string keys, so cell values (numbers or strings) match."
  [id->name]
  (into {} (map (fn [[id nm]] [(str id) nm])) id->name))

(defn table
  "Report table component: renders the query-injected `data` (a seq of string-keyed
   rows) as an amelia-light table, one column per `headers` entry. Each header is
   `{:key <query-column> :label <header> :value-type <optional>}`. A `:value-type` of
   \"location\" or \"concept\" maps that column's raw id to its name. Wrapped in a card
   so it can carry a title/description."
  [{:keys [title description headers data country-code]}]
  (let [location-id->name @(re/subscribe [:locations/location-id->label-by-current-concept-id-])
        concepts (util/when-not-loading @(re/subscribe [:concepts/list-data-]))
        id->name {"location" (->string-keyed location-id->name)
                  "concept" (into {}
                                  (keep (fn [{:keys [id label]}] (when (and id label) [(str id) label])))
                                  concepts)}
        loading? (util/loading? data)
        rows (when-not loading? data)
        headers (mapv util/->kebab-case-keywords
                      (or headers
                          (some->> data
                                   (first)
                                   (keys)
                                   (mapv (fn [k] {:key k :label (util/->capitalize-words k)})))))]
    [alc/card {:title title
               :subtitle description
               :style {:height "100%"}}
     [alc/table
      {:container-loading? loading?
       :headers (mapv (fn [{:keys [label]}] {:label label}) headers)
       :rows (mapv (fn [row]
                     {:cells (mapv (fn [{:keys [key value-type]}]
                                     (format-cell (get row key) value-type country-code id->name))
                                   headers)})
                   rows)}]]))
